import { Exception, SchemaErrorException } from '@nemuru-eng/js-api-client';

import { ErrorMessageDefault } from '@/components/shared/components/ErrorBoundary/components/ErrorMessage/components/ErrorMessageFactory/exceptions/ErrorMessageDefault';
import { ErrorMessageException } from '@/components/shared/components/ErrorBoundary/components/ErrorMessage/components/ErrorMessageFactory/exceptions/ErrorMessageException';
import { ErrorMessageZodSchema } from '@/components/shared/components/ErrorBoundary/components/ErrorMessage/components/ErrorMessageFactory/exceptions/ErrorMessageZodSchema';

export const ErrorMessageFactory = ({ error }: { error: Error }) => {
  if (error instanceof SchemaErrorException) {
    return <ErrorMessageZodSchema fields={error.fieldErrors} />;
  }
  if (error instanceof Exception) {
    return <ErrorMessageException message={error.message} />;
  }

  return <ErrorMessageDefault error={error} />;
};
